<template>
  <div class="mainDiv">
    <div class="checkbox-div">
      <p style="margin: 0; width: 60%">
        Does the farmer have any <span style="font-weight: 500">Land?</span>
      </p>
      <div class="check">
        <input
          @click="handleClick('land', 1)"
          type="checkbox"
          :checked="ownerFilterData.land.isLand == 1"
        />
        <p>Yes</p>
      </div>
      <div class="check">
        <input
          type="checkbox"
          @click="handleClick('land', 2)"
          :checked="ownerFilterData.land.isLand == 2"
        />
        <p>No</p>
      </div>
    </div>
    <div v-if="ownerFilterData.land.isLand == 1" class="question-tab">
      <p>How much land?</p>
      <div class="checkbox-div2">
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('land', '0-2')"
            :checked="
              this.ownerFilterData.land.landValue.includes('0-2') ? true : false
            "
          />
          <p>0-2 Acres</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('land', '2-5')"
            :checked="
              this.ownerFilterData.land.landValue.includes('2-5') ? true : false
            "
          />
          <p>2-5 Acres</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('land', '5-10')"
            :checked="
              this.ownerFilterData.land.landValue.includes('5-10')
                ? true
                : false
            "
          />
          <p>5-10 Acres</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('land', '10>')"
            :checked="
              this.ownerFilterData.land.landValue.includes('10>') ? true : false
            "
          />
          <p>10> Acres</p>
        </div>
      </div>
    </div>

    <div class="checkbox-div">
      <p style="margin: 0; width: 60%">
        Does the farmer have any <span style="font-weight: 500">Tractor?</span>
      </p>
      <div class="check">
        <input
          @click="handleClick('tractor', 1)"
          type="checkbox"
          :checked="ownerFilterData.tractor.isTractor == 1"
        />
        <p>Yes</p>
      </div>
      <div class="check">
        <input
          type="checkbox"
          @click="handleClick('tractor', 2)"
          :checked="ownerFilterData.tractor.isTractor == 2"
        />
        <p>No</p>
      </div>
    </div>
    <div v-if="ownerFilterData.tractor.isTractor == 1">
      <p style="margin: 0; margin-left: 32px; margin-top: 32px">
        Which brand of tractors ?
      </p>
      <ownership-multiple-button type="tractor" />
    </div>

    <div class="checkbox-div">
      <p style="margin: 0; width: 60%">
        Does the farmer have any <span style="font-weight: 500">Cattle?</span>
      </p>
      <div class="check">
        <input
          type="checkbox"
          @click="handleClick('cattle', 1)"
          :checked="ownerFilterData.cattle.isCattle == 1"
        />
        <p>Yes</p>
      </div>
      <div class="check">
        <input
          type="checkbox"
          @click="handleClick('cattle', 2)"
          :checked="ownerFilterData.cattle.isCattle == 2"
        />
        <p>No</p>
      </div>
    </div>
    <div v-if="ownerFilterData.cattle.isCattle == 1" class="question-tab">
      <p>How many cattles?</p>
      <div class="checkbox-div2">
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('cattle', '1')"
            :checked="
              this.ownerFilterData.cattle.quantity.includes('1')
                ? true
                : false
            "
          />
          <p>1 Cattle</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('cattle', '2')"
            :checked="
              this.ownerFilterData.cattle.quantity.includes('2')
                ? true
                : false
            "
          />
          <p>2 Cattle</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('cattle', '3')"
            :checked="
              this.ownerFilterData.cattle.quantity.includes('3')
                ? true
                : false
            "
          />
          <p>3 Cattle</p>
        </div>
        <div class="check">
          <input
            type="checkbox"
            @click="handleValues('cattle', '3>')"
            :checked="
              this.ownerFilterData.cattle.quantity.includes('3>')
                ? true
                : false
            "
          />
          <p>3> Cattle</p>
        </div>
      </div>
    </div>
    <div v-if="ownerFilterData.cattle.isCattle == 1">
      <p style="margin: 0; margin-left: 32px; margin-top: 32px">
        Which type of cattles ?
      </p>
      <ownership-multiple-button type="cattle" />
    </div>
  </div>
</template>
<script>
import ownershipMultipleButton from "./ownership-button.vue";
export default {
  name: "ownerShip",
  data() {
    return {
      questions: [
        "Does the farmer have any Land?",
        "Does the farmer have any Tractor?",
        "Does the farmer have any Cattle?",
      ],
      showLandQues: false,
      land: null,
      showTractor: false,
      showCattle: false,
      ownerFilterData: {
        land: {
          isLand: null,
          landValue: [],
          isClicked: 0,
        },
        tractor: {
          isTractor: false,
          brand: [],
          isClicked: 0,
        },
        cattle: {
          isCattle: false,
          quantity: [],
          type: [],
          isClicked: 0,
        },
      },
    };
  },
  components: {
    "ownership-multiple-button": ownershipMultipleButton,
  },
  created() {
    const data = this.$store.getters["crmFilters/GET_INSURANCE_DATA"];
    //   if(data.tractor)
    //   this.insurance.tractor=data.tractor
  },
  methods: {
     setOwnershipEngagementToStore() {
    this.$store.dispatch("crmFilters/setOwnership", {
      ownership: {
        land: {
          land_ownership:
            this.ownerFilterData.land.isLand == 1
              ? 1
              : this.ownerFilterData.land.isLand == 2
              ? 2
              : 0,
          land_holding_size: this.ownerFilterData.land.landValue,
        },
        tractor: {
          tractor_ownership:
            this.ownerFilterData.tractor.isTractor == 1
              ? 1
              : this.ownerFilterData.tractor.isTractor == 2
              ? 2
              : 0,
          tractor_brand: this.ownerFilterData.tractor.brand,
        },
        cattle: {
          animal_ownership:
            this.ownerFilterData.cattle.isCattle == 1
              ? 1
              : this.ownerFilterData.cattle.isCattle == 2
              ? 2
              : 0,
          animal_own_count: this.ownerFilterData.cattle.quantity,
          animal_interest: this.ownerFilterData.cattle.type,
        },
      },
    });
  },
    handleClick(type, val) {
      console.log("handleLandClick", type);

      if (type == "land") {
        let isLandValue = this.ownerFilterData.land.isLand;
        switch (val) {
          case 1:
            if (isLandValue === 1) {
              this.ownerFilterData.land.isClicked = false;
              this.ownerFilterData.land.isLand = 0;
              this.ownerFilterData.land.landValue = [];
            } else {
              isLandValue = val;
              this.ownerFilterData.land.isClicked = true;
              this.ownerFilterData.land.isLand = val;
            }
            break;
          case 2:
            if (isLandValue == 2) {
              isLandValue = 0;
              this.ownerFilterData.land.isClicked = false;
              this.ownerFilterData.land.isLand = 0;
              this.ownerFilterData.land.landValue = [];
            } else {
              this.ownerFilterData.land.isLand = val;
              this.ownerFilterData.land.isClicked = true;
              this.ownerFilterData.land.landValue = [];
            }
            break;
          case 0:
            if (isLandValue != 0) {
              this.ownerFilterData.land.isLand = val;
              this.ownerFilterData.land.isClicked = false;
              this.ownerFilterData.land.landValue = [];
            }
            break;

          default:
            break;
        }
      }
      if (type == "tractor") {
        let isTractorValue = this.ownerFilterData.tractor.isTractor;
        switch (val) {
          case 1:
            if (isTractorValue === 1) {
              this.ownerFilterData.tractor.isClicked = false;
              this.ownerFilterData.tractor.isTractor = 0;
              this.ownerFilterData.tractor.brand = [];
            } else {
              isTractorValue = val;
              this.ownerFilterData.tractor.isClicked = true;
              this.ownerFilterData.tractor.isTractor = val;
            }
            break;
          case 2:
            if (isTractorValue == 2) {
              
              this.ownerFilterData.tractor.isClicked = false;
              this.ownerFilterData.tractor.isTractor = 0;
              this.ownerFilterData.tractor.brand = [];
            } else {
              this.ownerFilterData.tractor.isTractor = val;
              this.ownerFilterData.tractor.isClicked = true;
              this.ownerFilterData.tractor.brand = [];
            }
            break;
          case 0:
            if (isTractorValue != 0) {
              this.ownerFilterData.tractor.isTractor = val;
              this.ownerFilterData.tractor.isClicked = false;
              this.ownerFilterData.tractor.brand = [];
            }
            break;

          default:
            break;
        }
      }
      if (type == "cattle") {
        let isCattleValue = this.ownerFilterData.cattle.isCattle;
        switch (val) {
          case 1:
            if (isCattleValue == 1) {
              this.ownerFilterData.cattle.isClicked = false;
              this.ownerFilterData.cattle.isCattle = 0;
              this.ownerFilterData.cattle.type = [];
              this.ownerFilterData.cattle.quantity = [];
            } else {
              isCattleValue = val;
              this.ownerFilterData.cattle.isClicked = true;
              this.ownerFilterData.cattle.isCattle = val;
            }
            break;
          case 2:
            if (isCattleValue == 2) {

              this.ownerFilterData.cattle.isClicked = false;
              this.ownerFilterData.cattle.isCattle = 0;
              this.ownerFilterData.cattle.type = [];
              this.ownerFilterData.cattle.quantity = [];
            } else {
              this.ownerFilterData.cattle.isCattle = val;
              this.ownerFilterData.cattle.isClicked = true;
              this.ownerFilterData.cattle.type = [];
              this.ownerFilterData.cattle.quantity = [];
            }
            break;
          case 0:
            if (isCattleValue != 0) {
              this.ownerFilterData.cattle.isCattle = val;
              this.ownerFilterData.cattle.isClicked = false;
              this.ownerFilterData.cattle.type = [];
              this.ownerFilterData.cattle.quantity = [];
            }
            break;

          default:
            break;
        }
      }

      console.log(this.ownerFilterData);
      this.setOwnershipEngagementToStore();
    },
    handleValues(type, val) {
      if (type == "land") {
        //  this.ownerFilterData.land.brand= this.ownerFilterData.land.landValue!=null? null :val;
        if (!this.ownerFilterData.land.landValue.includes(val)) {
          this.ownerFilterData.land.landValue.push(val);
        } else {
          const index = this.ownerFilterData.land.landValue.indexOf(val);
          if (index > -1) {
            this.ownerFilterData.land.landValue.splice(index, 1);
          }
        }
      }
      if (type == "cattle") {
        //  this.ownerFilterData.land.brand= this.ownerFilterData.land.landValue!=null? null :val;
        if (!this.ownerFilterData.cattle.quantity.includes(val)) {
          this.ownerFilterData.cattle.quantity.push(val);
        } else {
          const index = this.ownerFilterData.cattle.quantity.indexOf(val);
          if (index > -1) {
            this.ownerFilterData.cattle.quantity.splice(index, 1);
          }
        }
      }

      console.log(this.ownerFilterData);
      this.setOwnershipEngagementToStore();
    },
  },
  handleTractorValues(type, val) {
    if (type == "land") {
      //  this.ownerFilterData.land.brand= this.ownerFilterData.land.landValue!=null? null :val;
      if (!this.ownerFilterData.land.landValue.includes(val)) {
        this.ownerFilterData.land.landValue.push(val);
      } else {
        const index = this.ownerFilterData.land.landValue.indexOf(val);
        if (index > -1) {
          this.ownerFilterData.land.landValue.splice(index, 1);
        }
      }
    }
    console.log(this.ownerFilterData.land);
    this.setOwnershipEngagementToStore();
  },
 
};
</script>
<style lang="scss" scoped>
.mainDiv {
  width: 100%;
  overflow-y: scroll;
}
.checkbox-div {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 32px;
  margin-top: 48px;
  margin-left: 32px;
  .check {
    display: flex;
    align-items: center;
    gap: 12px;
    p {
      color: #4b4b4b;
      margin: 0;
    }
  }
}
.checkbox-div2 {
  display: flex;
  align-items: center;
  width: 40%;
  row-gap: 12px;
  column-gap: 32px;
  height: 60px;
  flex-wrap: wrap;
  .check {
    display: flex;
    align-items: center;
    gap: 12px;
    p {
      color: #4b4b4b;
    }
  }
}
.question-tab {
  display: flex;
  justify-content: space-between;
  margin-left: 32px;
  margin-top: 28px;
  p {
    margin: 0;
  }
}
input[type="checkbox"] {
  accent-color: #189d3b;
  height: 16px;
  width: 16px;
  border-radius: 4px;
}
</style>
